import { CircularProgress, Box } from '@mui/material';
import { useAuthContext } from './AuthContext';
import { LoginPage } from './LoginPage';
import { AccessDeniedPage } from './AccessDeniedPage';

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, isAccessDenied } = useAuthContext();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (isAccessDenied) {
    return <AccessDeniedPage />;
  }

  return <>{children}</>;
}
